module.exports = __webpack_public_path__ + "img/9788992525848.080d378f.jpg";